import { c as _c } from "react/compiler-runtime";
import type { GBFeatures } from "./configure-server-side";
const serializeFeatures = (features: GBFeatures) => {
  try {
    return JSON.stringify(features).replaceAll('<', "\\u003c");
  } catch {
    return "{}";
  }
};
export const InjectExperimentConfigScript = t0 => {
  const $ = _c(4);
  const {
    features
  } = t0;
  let t1;
  if ($[0] !== features) {
    t1 = serializeFeatures(features);
    $[0] = features;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `
              window.__GB_FEATURES__ = ${t1};
            `;
  let t3;
  if ($[2] !== t2) {
    t3 = <script dangerouslySetInnerHTML={{
      __html: t2
    }} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};